'use strict';

var MapActionsFactory = function (Flux, SB_MAP_DISPATCHER_ID) {

  var ActionsUtil = Flux.Actions;

  function getActions (mapId) {

    var actionsId = getActionsId(mapId);
    var Actions = ActionsUtil.create(actionsId, SB_MAP_DISPATCHER_ID);

    Actions.add({
      name: 'LeafletLayerAdd',
      purpose: 'The leaflet has registered a new layer',
      payload: ['data']
    });

    Actions.add({
      name: 'EditedActiveLayer',
      purpose: 'The active layer has either moved or the shape has changed',
      payload: ['wlayer']
    });

    Actions.add({
      name: 'CloseActiveLayerPopup',
      purpose: 'The popup has been closed from the map and content cleanup should occur. The layer is sent to signal which layer triggered the close to prevent accidental closure.',
      payload: ['layer']
    });

    Actions.add({
      name: 'OpenActiveLayerPopup',
      purpose: 'The popup for the layer has been opened on the map and content should be rendered.',
      payload: []
    });

    Actions.add({
      name: 'SetActiveLayerPopupContent',
      purpose: 'Set active layer popup content.',
      payload: ['content']
    });

    Actions.add({
      name: 'SetActiveLayer',
      purpose: 'Set the active layer (raw). Popup latLng will be available if the layer was clicked directly.',
      payload: ['layer']
    });

    Actions.add({
      name: 'UnsetActiveLayer',
      purpose: 'Make sure the specified layer is no longer the active one.',
      payload: ['layer']
    });

    Actions.add({
      name: 'RegisterLayer',
      purpose: 'Register a rendered layer with the MapStore',
      payload: ['layer', 'collection']
    });

    Actions.add({
      name: 'ResetLayers',
      purpose: 'Reset the specified collection of rendered layers',
      payload: ['collection']
    });

    Actions.add({
      name: 'SetEditableTypes',
      purpose: 'Set the specified layer types to be editable or not',
      payload: ['types']
    });

    Actions.add({
      name: 'SetOpacityValues',
      purpose: 'Set the opacity values of the map and datacapture when the slider is changed',
      payload: ['opacities']
    });

    return Actions;
  }

  function getActionsId (mapId) {
    return [mapId, 'MapActions'].join('');
  }

  return {
    create: function (mapId) {
      return getActions(mapId);
    },

    get: function (mapId) {
      var id = getActionsId(mapId);
      return ActionsUtil.get(id);
    }
  };
};

MapActionsFactory.$inject = ['sbFlux', 'SB_MAP_DISPATCHER_ID'];
module.exports = MapActionsFactory;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/MapActions.js